import { EnrollToAnotherProgramComponent } from './pages/patients/enroll-to-another-program/enroll-to-another-program.component';
import { LcaPatientsComponent } from './pages/lca-patients/lca-patients.component';
import { TestRequestDetailsComponent } from './pages/patients/test-request-details/test-request-details.component';
import { SpecialityReportComponent } from './pages/Specialties/components/speciality-report/speciality-report.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { AllAppointmentsComponent } from './pages/appointments/all-appointments/all-appointments.component';
import { LiveAppointmentsComponent } from './pages/appointments/live-appointments/live-appointments.component';
import { AddBranchComponent } from './pages/branches/add-branch/add-branch.component';
import { BranchesPerLabListComponent } from './pages/branches/branches-per-lab-list/branches-per-lab-list.component';
import { AddCenterComponent } from './pages/centers/add-center/add-center.component';
import { CentersListComponent } from './pages/centers/centers-list/centers-list.component';
import { CetnerTestComponent } from './pages/centers/cetner-test/cetner-test.component';
import { HomeVisitFeesListComponent } from './pages/centers/home-visit-fees-list/home-visit-fees-list.component';
import { HomeVisitFeesComponent } from './pages/centers/home-visit-fees/home-visit-fees.component';
import { AddCouponComponent } from './pages/coupons/add-coupon/add-coupon.component';
import { CouponsListComponent } from './pages/coupons/coupons-list/coupons-list.component';
import { AddDoctorComponent } from './pages/doctors/add-doctor/add-doctor.component';
import { DoctorsLisitingComponent } from './pages/doctors/doctors-lisiting/doctors-lisiting.component';
import { FeaturedDoctorsListComponent } from './pages/doctors/featured-doctors/featured-doctors-list/featured-doctors-list.component';
import { UpdateFeaturedDoctorComponent } from './pages/doctors/featured-doctors/update-featured-doctor/update-featured-doctor.component';
import { AddFaqComponent } from './pages/FAQ/add-faq/add-faq.component';
import { FaqListComponent } from './pages/FAQ/faq-list/faq-list.component';
import { AddAreaComponent } from './pages/geo-info/areas/add-area/add-area.component';
import { AreasListComponent } from './pages/geo-info/areas/areas-list/areas-list.component';
import { AddCityComponent } from './pages/geo-info/cities/add-city/add-city.component';
import { CitiesListComponent } from './pages/geo-info/cities/cities-list/cities-list.component';
import { AddLatestOfferComponent } from './pages/offers/add-latest-offer/add-latest-offer.component';
import { LatestOffersComponent } from './pages/offers/latest-offers/latest-offers.component';
import { EmergencyPatientsComponent } from './pages/patients/emergency-patients/emergency-patients.component';
import { PatientDetailsComponent } from './pages/patients/patient-details/patient-details.component';
import { PatientsListComponent } from './pages/patients/patients-list/patients-list.component';
import { RequestPickUpComponent } from './pages/patients/request-pick-up/request-pick-up.component';
import { ViewMedicationRequestsComponent } from './pages/patients/view-medication-requests/view-medication-requests.component';
import { AddPaymentMethodComponent } from './pages/payment/add-payment-method/add-payment-method.component';
import { PaymentMethodsListComponent } from './pages/payment/payment-methods-list/payment-methods-list.component';
import { DailyTasksComponent } from './pages/psp/daily-tasks/daily-tasks.component';
import { PushNotificationsComponent } from './pages/push-notifications/push-notifications.component';
import { AddLatestServiceComponent } from './pages/services/add-latest-service/add-latest-service.component';
import { LatestServicesListComponent } from './pages/services/latest-services-list/latest-services-list.component';
import { AddSpecialityComponent } from './pages/Specialties/add-speciality/add-speciality.component';
import { SpecialtiesComponent } from './pages/Specialties/specialties/specialties.component';
import { TestRequestsListComponent } from './pages/test-requests/test-requests-list/test-requests-list.component';
import { UploadTestResultComponent } from './pages/test-requests/upload-test-result/upload-test-result.component';
import { AddTestComponent } from './pages/tests/add-test/add-test.component';
import { TestsListComponent } from './pages/tests/tests-list/tests-list.component';
import { ReportsComponent } from './pages/reports/reports.component';
import { CouponDetailsComponent } from './pages/coupons/coupon-details/coupon-details.component';
import { RequestHomeDeliveryComponent } from './pages/patients/request-home-delivery/request-home-delivery.component';
import { AddTestCouponComponent } from './pages/coupons/add-test-coupon/add-test-coupon.component';
import { AddAppointmentCouponComponent } from './pages/coupons/add-appointment-coupon/add-appointment-coupon.component';
import { TestCouponDetailsComponent } from './pages/coupons/test-coupon-details/test-coupon-details.component';
import { AppointmentCouponDetailsComponent } from './pages/coupons/appointment-coupon-details/appointment-coupon-details.component';
import { PrescriptionFulfillmentRequestsComponent } from './pages/prescription-fulfillment/prescription-fulfillment-requests/prescription-fulfillment-requests.component';
import { PrescriptionRequestDetailsComponent } from './pages/prescription-fulfillment/prescription-request-details/prescription-request-details.component';
import { NewTestRequestComponent } from './pages/patients/new-test-request/new-test-request.component';
import { MedicalTestsComponent } from './pages/patients/medical-tests/medical-tests.component';
import { EmrMedicationsComponent } from './pages/patients/emr-medications/emr-medications.component';
import { EmrPrescriptionDetailsComponent } from './pages/patients/emr-prescription-details/emr-prescription-details.component';
import { UploadingToolComponent } from './pages/uploading-tool/uploading-tool.component';
import { HospitalProceduresComponent } from './pages/patients/hospital-procedures/hospital-procedures.component';
import { EmrHospitalprocedureDetailsComponent } from './pages/patients/emr-hospitalprocedure-details/emr-hospitalprocedure-details.component';
import { VitalsDataComponent } from './pages/patients/vitals-data/vitals-data.component';
import { ViewEditSubscriptionComponent } from './pages/patients/view-edit-subscription/view-edit-subscription.component';
import {ViewFlaggingTrackingComponent} from './pages/patients/view-flagging-tracking/view-flagging-tracking.component';
import { EmergencyCardComponent } from './pages/emergency-card/emergency-card.component';
import { EmergencyManagementComponent } from './pages/emergency-management/emergency-management.component';

const routes: Routes = [
  {
    path: '',
    component: AdminLayoutComponent,
    children: [
      { path: 'offers', component: LatestOffersComponent },
      { path: 'offers/add', component: AddLatestOfferComponent },
      { path: 'offers/edit/:offerId', component: AddLatestOfferComponent },
      {
        path: 'prescription-fulfillments/:type',
        component: PrescriptionFulfillmentRequestsComponent,
      },
      {
        path: 'prescription-fulfillment/:prescriptionId',
        component: PrescriptionRequestDetailsComponent,
      },
      { path: 'services', component: LatestServicesListComponent },
      { path: 'services/add', component: AddLatestServiceComponent },
      {
        path: 'services/edit/:serviceId',
        component: AddLatestServiceComponent,
      },
      { path: 'tests', component: TestsListComponent },
      { path: 'tests/add', component: AddTestComponent },
      { path: 'tests/edit/:testId', component: AddTestComponent },
      { path: 'centers', component: CentersListComponent },
      { path: 'centers/add', component: AddCenterComponent },
      { path: 'centers/edit/:centerId', component: AddCenterComponent },
      { path: 'centers/tests/:centerId', component: CetnerTestComponent },
      {
        path: 'centers/homeFeesList/:centerId',
        component: HomeVisitFeesListComponent,
      },
      {
        path: 'centers/homeFeesList/:centerId/add',
        component: HomeVisitFeesComponent,
      },
      {
        path: 'centers/homeFeesList/:centerId/edit/:feeId',
        component: HomeVisitFeesComponent,
      },

      {
        path: 'geo',
        children: [
          { path: 'cities', component: CitiesListComponent },
          { path: 'cities/add', component: AddCityComponent },
          { path: 'cities/edit/:cityId', component: AddCityComponent },
          { path: 'areas', component: AreasListComponent },
          { path: 'areas/add', component: AddAreaComponent },
          { path: 'areas/edit/:areaId', component: AddAreaComponent },
          { path: 'areasByCity/:cityId/add', component: AddAreaComponent },
          {
            path: 'areasByCity/:cityId/edit/:areaId',
            component: AddAreaComponent,
          },
          { path: 'areasByCity/:cityId', component: AreasListComponent },
        ],
      },
      { path: 'specialties', component: SpecialtiesComponent },
      { path: 'specialties/add', component: AddSpecialityComponent },
      {
        path: 'specialties/edit/:specialtyId',
        component: AddSpecialityComponent,
      },
      {
        path: 'specialties/:specialtyId',
        component: SpecialityReportComponent,
      },
      {
        path: 'appointments',
        children: [
          { path: 'allappointments', component: AllAppointmentsComponent },
          { path: 'liveappointments', component: LiveAppointmentsComponent },
        ],
      },
      { path: 'doctors', component: DoctorsLisitingComponent },
      { path: 'doctors/add', component: AddDoctorComponent },
      { path: 'doctors/edit/:doctorId', component: AddDoctorComponent },
      { path: 'featuredDoctors', component: FeaturedDoctorsListComponent },
      {
        path: 'featuredDoctors/edit/:featuredDoctorId',
        component: UpdateFeaturedDoctorComponent,
      },

      { path: 'paymentMethods', component: PaymentMethodsListComponent },
      { path: 'paymentMethods/add', component: AddPaymentMethodComponent },
      {
        path: 'paymentMethods/edit/:methodId',
        component: AddPaymentMethodComponent,
      },

      { path: 'coupons', component: CouponsListComponent },
      { path: 'coupons/add', component: AddCouponComponent },
      { path: 'coupons/add-coupon/test', component: AddTestCouponComponent },
      {
        path: 'coupons/add-coupon/appointment',
        component: AddAppointmentCouponComponent,
      },
      { path: 'coupons/edit/:couponId', component: AddCouponComponent },
      { path: 'coupon-details/:couponId', component: CouponDetailsComponent },
      {
        path: 'test-coupon-details/:couponId',
        component: TestCouponDetailsComponent,
      },
      {
        path: 'appointment-coupon-details/:couponId',
        component: AppointmentCouponDetailsComponent,
      },

      { path: 'faqs', component: FaqListComponent },
      { path: 'faqs/edit/:faqId', component: AddFaqComponent },
      { path: 'faqs/add', component: AddFaqComponent },
      { path: 'test-request', component: TestRequestsListComponent },
      {
        path: 'test-request/edit/:reqId',
        component: UploadTestResultComponent,
      },

      { path: 'branches/:centerId', component: BranchesPerLabListComponent },
      { path: 'branches/:centerId/add', component: AddBranchComponent },
      {
        path: 'branches/:centerId/edit/:branchId',
        component: AddBranchComponent,
      },

      { path: 'emergency-patients', component: EmergencyPatientsComponent },
      { path: 'emergency-card', component: EmergencyCardComponent },
      { path: 'emergency-management', component: EmergencyManagementComponent },
      { path: 'push-notifications', component: PushNotificationsComponent },

      { path: 'patients', component: PatientsListComponent },
      {
        path: 'patient-details/:patientId',
        component: PatientDetailsComponent,
      },
      {
        path: 'patient-details/:patientId/enroll-to-another-program',
        component: EnrollToAnotherProgramComponent,
      },
      {
        path: 'patient-details/:patientId/medical-tests',
        component: MedicalTestsComponent,
      },
      {
        path: 'patient-details/:patientId/hospital-Procedures',
        component: HospitalProceduresComponent,
      },
      {
        path: 'patient-details/:patientId/hospital-Procedures/:prescriptionSourceType/:hospitalProcedureId',
        component: EmrHospitalprocedureDetailsComponent,
      },
      {
        path: 'patient-details/:patientId/medications',
        component: EmrMedicationsComponent,
      },
      {
        path: 'patient-details/:patientId/medications/:prescriptionSourceType/:prescriptionId',
        component: EmrPrescriptionDetailsComponent,
      },
      {
        path: 'patient-details/:patientId/add-new-test',
        component: NewTestRequestComponent,
      },
      { path: 'lca-patients', component: LcaPatientsComponent },
      {
        path: 'test-request-details',
        component: TestRequestDetailsComponent,
      },
      {
        path: 'test-request-details/:testRequestId',
        component: TestRequestDetailsComponent,
      },
      {
        path: 'patient-details/:patientId/view-medication-details/:programId',
        component: ViewMedicationRequestsComponent,
      },
      {
        path: 'request-pickup/:patientId/:subscriptionId',
        component: RequestPickUpComponent,
      },
      {
        path: 'request-home-delivery/:patientId/:subscriptionId',
        component: RequestHomeDeliveryComponent,
      },
      {
        path: 'psp',
        loadChildren: () =>
          import('./pages/psp/psp.module').then((m) => m.PspModule),
      },
      { path: 'reports', component: ReportsComponent },
      {
        path: 'uploading-tool',
        component: UploadingToolComponent,
      },
      {
        path: 'patient-details/:patientId/vitals-data',
        component: VitalsDataComponent
      },
      {
        path: 'view-edit-subscription/:patientId/:subscriptionId',
        component: ViewEditSubscriptionComponent,
      },
      {
        path: 'flagging-tracking/:subscriptionId',
        component: ViewFlaggingTrackingComponent,
      }
    ],
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./layout/auth-layout/auth-layout.module').then(
            (m) => m.AuthLayoutModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
